module.exports = __webpack_public_path__ + "img/brand_nav_green.77cda6cb.svg";